// extracted by mini-css-extract-plugin
export default {"editor":"style_editor__ricSF","boldHighlightHtags":"style_boldHighlightHtags__lty1A","secA":"style_secA__7PtY+"};